// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Component({
    selector: 'page-fix-summary-change-types',
    standalone: false,
    template: `
        <mon-chart-bar
            [height]="'235'"
            [labels]="chartLabels"
            [data]="chartData"
            [options]="chartOptions"
            [override]="chartOverrides"
            [colors]="barColors">
        </mon-chart-bar>
    `,
})
export class PageFixSummaryChangeTypesComponent implements OnInit {
    @Input() spellingFixes: any;
    @Input() links: any;
    @Input() accessibilitySourceCodes: any;
    @Input() accessibilityChecks: any;
    @Input() customFixes: any;

    chartLabels: any = [];
    chartSeries: any = [''];
    barColors: any = [];
    chartData: any = [[]];
    chartOptions: any;
    chartOverrides: any;

    constructor (
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        const canAccessAccessibilityCheck = this.activeFeatureService.isFeatureActive('page_fix_accessibility_check');
        const canAccessAccessibilitySourceCode = this.activeFeatureService.isFeatureActive(
            'page_fix_accessibility_source_code',
        );
        const canAccessQALinks = this.activeFeatureService.isFeatureActive('page_fix_qa_links');
        const canAccessQAMisspellings = this.activeFeatureService.isFeatureActive('page_fix_qa_misspelling');
        const canAccessCustom = this.activeFeatureService.isFeatureActive('page_fix_qa_custom');

        this.chartLabels = [];
        this.chartSeries = [''];
        this.barColors = [];
        this.chartData = [[]];

        if (canAccessQAMisspellings) {
            this.chartLabels.push(this.translateService.getString('Spelling fixes'));
            this.barColors.push('#a8d6f3');
            this.chartData[0].push(this.spellingFixes);
        }

        if (canAccessQALinks) {
            this.chartLabels.push(this.translateService.getString('Link fixes'));
            this.barColors.push('#a8d6f3');
            this.chartData[0].push(this.links);
        }

        if (canAccessAccessibilityCheck || canAccessAccessibilitySourceCode) {
            this.chartLabels.push(this.translateService.getString('Accessibility fixes'));
            this.barColors.push('#a8d6f3');
            this.chartData[0].push(this.accessibilityChecks + this.accessibilitySourceCodes);
        }

        if (canAccessCustom) {
            this.chartLabels.push(this.translateService.getString('Custom fixes'));
            this.barColors.push('#a8d6f3');
            this.chartData[0].push(this.customFixes);
        }

        const max = this.chartData[0].reduce(function (a: any, b: any) {
            return Math.max(a, b);
        }, 0);

        this.chartOptions = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-0',
                        ticks: {
                            min: 0,
                            max: max * 1.5,
                        },
                        display: false,
                        gridLines: {
                            display: false,
                        },
                    },
                ],
                xAxes: [
                    {
                        barPercentage: 1,
                        categoryPercentage: 0.5,
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            fontColor: '#a6a6a6',
                            fontSize: 11,
                        },
                    },
                ],
            },
            drawLabelOnChart: true,
        };

        this.chartOverrides = [
            {
                borderWidth: 0,
                backgroundColor: 'rgba(54, 162, 235, 0.5)',
            },
        ];
    }
}
